import PublicRoomContainer from 'components/views/PublicRoom/_components/PublicRoomContainer';
import CompanySnapshotRow from 'components/global/CompanySnapShotRow/CompanySnapshotRow';
import { formatMoneyNoDecimals } from 'utils/formatMoney';
import Loadable from 'components/global/Loadable';
import { $detail } from 'signals/global.signals';
import SimpleCard from 'components/global/SimpleCard';

const PublicRoomCompanySnapshot = () => (
  <PublicRoomContainer>
    <SimpleCard>
      <Loadable signal={$detail}>
        <CompanySnapshotRow label="Company Name" value={$detail.value?.companyName} />
        <CompanySnapshotRow label="Company Overview" value={$detail.value?.companyDescription} />
        <CompanySnapshotRow label="Company Website" value={$detail.value?.website} />
        <CompanySnapshotRow label="Company Location" value={$detail.value?.location} />
        <CompanySnapshotRow label="Investment Stage" value={$detail.value?.investmentStage} />
        {$detail.value.isMrrIncluded && (
          <CompanySnapshotRow label="Monthly Recurring Revenue" value={formatMoneyNoDecimals($detail.value.mrr || 0)} />
        )}
        {$detail.value.isArrIncluded && (
          <CompanySnapshotRow label="Annual Recurring Revenue" value={formatMoneyNoDecimals($detail.value.arr || 0)} />
        )}
        {$detail.value.isCashOnHandIncluded && (
          <CompanySnapshotRow label="Cash on Hand" value={formatMoneyNoDecimals($detail.value.cashOnHand || 0)} />
        )}
        {$detail.value.isLiabilitiesIncluded && (
          <CompanySnapshotRow label="Liabilities" value={formatMoneyNoDecimals($detail.value.liabilities || 0)} />
        )}
        {$detail.value.isOtherAssetsIncluded && (
          <CompanySnapshotRow label="Other Assets" value={formatMoneyNoDecimals($detail.value.otherAssets || 0)} />
        )}
      </Loadable>
    </SimpleCard>
  </PublicRoomContainer>
);

export default PublicRoomCompanySnapshot;
